var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcTranslateBlueSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.444 6.973a1 1 0 011 1v11.285a1 1 0 01-1 1h-6.888L8.444 6.973h11zm-.6 1h-9.4l3.427 11.28h5.973a.6.6 0 00.6-.6V8.573a.6.6 0 00-.6-.6z",
    fill: "#655AEC",
    opacity: 0.795
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.795,
    fillRule: "nonzero",
    stroke: "#655AEC",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.76 11.123H11.77M14.765 10.055v1.068M16.266 11.11c0 2.734-2.016 4.945-4.5 4.945M17.765 16.055c-1.08 0-2.04-.61-2.73-1.57"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4F45CE",
    d: "M15.444 17.114l-2.888 3.144-1.496-4.386z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55 3.75h6.51l4.384 13.364H4.55a1 1 0 01-1-1V4.75a1 1 0 011-1z",
    fill: "#655AEC"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.13 13.055l-2.691-6-2.692 6M6.554 11.642h3.68"
  })))));
}

export default SvgIcTranslateBlueSvg;